import Chip from "@mui/material/Chip";
import Stack from "@mui/material/Stack";
import type { CompanyTechnology } from "../../../api/client.ts";
import Panel from "../../../components/Panel.tsx";

interface TechnologiesCardProps {
  technologies: CompanyTechnology[];
}

export default function TechnologiesCard({ technologies }: TechnologiesCardProps) {
  if (technologies.length === 0) return null;
  return (
    <Panel title="Technologies" count={technologies.length} sx={{ mb: 3 }}>
      <Stack direction="row" spacing={0.5} useFlexGap sx={{ flexWrap: "wrap" }}>
        {technologies.map((tech) => (
          <Chip
            key={tech.id}
            label={tech.version ? `${tech.name} ${tech.version}` : tech.name}
            title={tech.category ? `${tech.category} (${tech.confidence}%)` : `${tech.confidence}%`}
          />
        ))}
      </Stack>
    </Panel>
  );
}
